export enum Role {
  USER = 'user',
  CLIENT = 'client',
  ADMIN = 'admin',
}
